/* eslint-env browser, jquery */
import page from 'modules/ab-page-js';

export default function register() {
  page('/blog/(.*)?', replace());
}

/**
 * Page.js middleware for path
 * replacing
 *
 * @param {String} path
 * @return {Function} middleware
 * @api private
 */

function replace(path) {
  return function middleware(ctx, next) {
    if (ctx.title.toLowerCase().indexOf('not found') === 0) {
      return;
    }

    path = path || ctx.path;
    window.location.replace(path);
  };
}



// WEBPACK FOOTER //
// ./src/pages/blog/client.js